import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { faS } from '@fortawesome/free-solid-svg-icons';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

const BrandCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [name, setName] = useState("");

    const [isSubmit, setIsSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");


    const clearForm = () => {
        setName("");
    };

    const submitData = async (e) => {
        e.preventDefault();

        setIsLoading(true);

        if (!name) { // Check if the category is selected
            setErrorMessage("All fields are required!");
            setIsSubmit(false);
            setIsLoading(false);
            return;
        }

        const CreateData = {
            Name: name,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('BrandApi', CreateData, token)
            .then((response) => {
                console.log('Item Group Created success:', response);
                setSuccessMessage("Item Group Created successfully!");
                setErrorMessage("");
                history.push('/BrandIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Group Create error:', error);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Brand Create</h6>

                        <Button

                            style={{ marginLeft: '8px', color: 'darkgreen', fontWeight: 'bolder' }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <CheckCircleOutlineIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} /> {isLoading ? <CircularProgress size={24} color="inherit" /> : <b>SAVE</b>}

                        </Button>
                        <Button

                            component={Link}
                            to="/BrandIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }}
                        >
                            <ArrowCircleLeftIcon style={{ marginLeft: '8px', color: 'brown', fontWeight: 'bolder' }} /> BACK TO LIST
                        </Button>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}
                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>
                    <div className="w-full mb-4 flex">
                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Brand Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                placeholder="Enter Name"
                            />
                        </div>

                    </div>

                </form>
            </div>
        </Fragment>
    );
};

export default BrandCreate;
